import { TrendColor } from '../pages/DashboardContext';

const normalizeColorKey = (c: string) => c.trim().toLowerCase();

const UNIQUE_FALLBACK_PALETTE = [
  '#a36a5e',
  '#c0504d',
  '#9bbb59',
  '#8064a2',
  '#33464b',
  '#f79646',
  '#1f77b4',
  '#ff7f0e',
  '#2ca02c',
  '#d62728',
  '#9467bd',
  '#007e8c',
].map((x) => x.toLowerCase());

const stringToStableIndex = (key: string, mod: number) => {
  let acc = 0;
  for (let i = 0; i < key.length; i += 1) {
    acc = (acc * 31 + key.charCodeAt(i)) % mod;
  }
  return acc;
};

const createUniqueColorAllocator = () => {
  const used = new Set<string>();
  const assignedByKey = new Map<string, string>();
  return (key: string, baseColor: string): string => {
    if (!baseColor) return baseColor;
    const cached = assignedByKey.get(key);
    if (cached) return cached;

    const baseKey = normalizeColorKey(baseColor);
    if (!used.has(baseKey)) {
      used.add(baseKey);
      assignedByKey.set(key, baseColor);
      return baseColor;
    }

    const start = stringToStableIndex(key, UNIQUE_FALLBACK_PALETTE.length);
    for (let i = 0; i < UNIQUE_FALLBACK_PALETTE.length; i += 1) {
      const candidate = UNIQUE_FALLBACK_PALETTE[(start + i) % UNIQUE_FALLBACK_PALETTE.length];
      if (!used.has(candidate)) {
        used.add(candidate);
        assignedByKey.set(key, candidate);
        return candidate;
      }
    }

    assignedByKey.set(key, baseColor);
    return baseColor;
  };
};

export const getTrendId = (trend: { campaign?: string | null; offer?: string | null } | null | undefined) => {
  if (!trend) return '';
  if (trend.offer) return `OFFER___${trend.offer}`;
  return trend.campaign || '';
};

export const buildUniqueTrendColorMap = (trendColors: TrendColor[]) => {
  const allocateUniqueColor = createUniqueColorAllocator();
  const map = new Map<string, string>();

  trendColors.forEach((t) => {
    const key = 'isSummary' in t ? 'Summary' : getTrendId(t);
    if (!key) return;
    const unique = allocateUniqueColor(key, t.color || '');
    map.set(key, unique);
  });

  return map;
};

